import React, { useMemo } from 'react';
import ComponentAlertRow from './ComponentAlertRow';
import { getComponentSeverity } from './componentSeverity';
import StatusPill from '../../../shared/components/pill/StatusPill';

function getComponentRole(component) {
  if (component.metadata?.role) return component.metadata.role;
  if (component.component_type === 'pm') return 'Power Module';
  if (component.component_type === 'connector') return 'Connector';
  return component.component_type || 'Component';
}

function getModelString(component) {
  let result = component.name || component.metadata?.model_name || component.component_type || 'Unknown Model';
  const generation = component.metadata?.generation;
  if (generation) result += ` gen ${generation}`;
  return result;
}

export default function ComponentCard({ component }) {
  const role = getComponentRole(component);
  const model = getModelString(component);
  const serial = component.metadata?.serial_number || component.external_key || 'Unknown';
  const alerts = useMemo(
    () => (Array.isArray(component.conditions) ? component.conditions : []),
    [component.conditions]
  );
  const severity = getComponentSeverity(component);

  const tone = severity === 'ok' ? 'success' : severity === 'warning' ? 'warning' : 'danger';

  return (
    <div className="mb-2 px-3 pt-3 pb-0">
      <hr className="my-0 mb-3" />
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <div className="bg-light rounded-4 p-3 d-flex align-items-center justify-content-center">
            <i className="bi bi-puzzle-fill fs-2 text-primary" />
          </div>
          <div>
            <div className="text-muted text-uppercase small mb-1">{role}</div>
            <div className="fw-bold fs-5 mb-1">{model}</div>
            <div className="text-muted fw-semibold" style={{ fontSize: '1.07rem' }}>
              SN: {serial}
            </div>
          </div>
        </div>
        <div>
          <StatusPill tone={tone} size="touch">
            {severity === 'ok' ? 'OK' : severity === 'warning' ? 'Warning' : 'Fault'}
          </StatusPill>
        </div>
      </div>
      {alerts.length > 0 && (
        <div className="mt-3">
          {alerts.map((alert, idx) => (
            <ComponentAlertRow
              key={alert.id || idx}
              alert={alert}
              severity={alert.severity === 'error' ? 'fault' : 'warning'}
            />
          ))}
        </div>
      )}
    </div>
  );
}
